export default __webpack_public_path__ + "static/media/icon-cart2.761c9f26.svg";